import React from 'react';
import { ScrollToTopSection } from './about/ScrollToTopSection';
import { EyebrowSection } from './about/EyebrowSection';
import { HeaderSection } from './about/HeaderSection';
import { HeroSection } from './about/HeroSection';
import { ValuesSection } from './about/ValuesSection';
import { CTASection } from './about/CTASection';
import { FooterSection } from './about/FooterSection';
export function AboutPage() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-179">
      <ScrollToTopSection data-id="element-180" />
      <EyebrowSection data-id="element-181" />
      <HeaderSection data-id="element-182" />
      <main className="flex-grow" data-id="element-183">
        <HeroSection data-id="element-184" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-185">
          <ValuesSection data-id="element-186" />
          <CTASection data-id="element-187" />
        </div>
      </main>
      <FooterSection data-id="element-188" />
    </div>;
}